export default __webpack_public_path__ + "static/media/bin-types-photo.8b86c131.png";